import { useSyncExternalStore } from 'react'
import { currentFeatures, subscribeFeatures } from '../data/features'
import type { SiteFeatures } from '../core/types/site'

/**
 * Welke onderdelen aan staan (fotodagboek, abonnement). De enige plek waar schermen dit lezen;
 * de regel zelf staat in core/rules/features.ts. Werkt bij als de instellingen veranderen.
 */
export function useFeatures(): SiteFeatures {
  return useSyncExternalStore(subscribeFeatures, currentFeatures, currentFeatures)
}
